export const TOGGLE_CHARGE_CARD_FEEDBACK = 'TOGGLE_CHARGE_CARD_FEEDBACK';
export const TOGGLE_REMINDER_POPUP = 'TOGGLE_REMINDER_POPUP';
export const CLOSE_ALL_POPUPS = 'CLOSE_ALL_POPUS';

export const toggleChargeCardFeedback = () => ({ type: TOGGLE_CHARGE_CARD_FEEDBACK });

export const toggleReminderPopup = (open = true) => ({ type: TOGGLE_REMINDER_POPUP, open });

export const closeAllPopups = () => ({ type: CLOSE_ALL_POPUPS });



// WEBPACK FOOTER //
// ./src/actions/popupActions.js